import React from "react";
import PropTypes from "prop-types";
import { Button as SemanticButton } from "semantic-ui-react";
import "./Button.scss";

const SemanticSIZES = [
  "mini",
  "tiny",
  "small",
  "medium",
  "large",
  "big",
  "huge",
  "massive",
];

const SizeChart = {
  xxs: "mini",
  xs: "tiny",
  sm: "small",
  md: "medium",
  lg: "large",
  xl: "big",
  xxl: "huge",
  xxxl: "massive",
};

export const Button = ({
  color,
  size = "sm",
  label,
  outlined = false,
  disabled = false,
  ...props
}) => {
  const convertSizeToSemantic = (size) => {
    if (SemanticSIZES.includes(size)) {
      return size;
    }
    return SizeChart[size];
  };

  return (
    <SemanticButton
      size={convertSizeToSemantic(size)}
      basic={outlined}
      disabled={disabled}
      {...props}
      className={`hireart-ds-button ${color || "primary"} ${props.className} ${
        props.alternate ? "alternate" : ""
      }`}
    >
      {props.children || label}
    </SemanticButton>
  );
};

Button.propTypes = {
  outlined: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  label: PropTypes.string,
  color: PropTypes.string,
  alternate: PropTypes.bool,
  circular: PropTypes.bool,
};

